var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-between h-16 w-screen"},[_c('div',{staticClass:"left-panel flex items-center"},[_c('i',{staticClass:"text-2xl cursor-pointer",class:{
        'el-icon-s-fold': !_vm.isCollapse,
        'el-icon-s-unfold': _vm.isCollapse,
      },on:{"click":_vm.changeIsCollapse}}),_c('breadcrum',{staticClass:"ml-3"})],1),_c('div',{staticClass:"right-panel"},[_c('user-operation')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }